jQuery(function ($) {

    let $subscribeApp = $('#subscribe-app');

    if($subscribeApp.length){
        new Vue({
            el: "#subscribe-app",
            data: {
                loading: true,
                failedMessage: '',
                step: 1,
                form: {
                    agree: false,
                    email: '',
                    firstname: '',
                    lastname: '',
                    language: '',
                },
                errors: {},
            },
            methods: {

                submitForm() {

                    this.loading = true;
                    this.failedMessage = '';

                    // Сброс ошибок
                    this.errors = {};

                    let data = this.form;

                    // perform validations on the non-Hosted Fields inputs
                    axios.post('/wp-admin/admin-ajax.php?action=subscribe', data).then((response) => {
                    //axios.post('/wp-json/ma-api-1/subscribe/', data).then((response) => {

                        //console.log(response);

                        this.loading = false;
                        this.failedMessage = '';

                        if (response.data.result) {
                            this.step = 2;

                            /*let carrotquest_api_key = ma_ajax.carrotquest_api_key;
                            if(!carrotquest_api_key){
                                console.warn('carrotquest api key not found in ma_ajax.');
                                return;
                            }

                            if(!carrotquest){
                                console.warn('carrotquest not found.');
                                return;
                            }

                            carrotquest.connect(carrotquest_api_key);*/

                            let track_data = {
                                page_lang: ma_ajax.lang,
                                page_url: ma_ajax.request_url,
                                page_name: ma_ajax.title
                            }

                            if(response.data.email){
                                track_data.$email = response.data.email;
                            }
                            if(response.data.firstname && response.data.lastname){
                                track_data.$name = response.data.firstname + ' ' + response.data.lastname;
                            }

                            //carrotquest.track('Подписка на новости', track_data);

                        }
                        else {
                            if(response.data.message.length){
                                this.failedMessage = response.data.message;
                            }
                        }

                    }).catch((error) => {
                        console.error(error);
                        this.loading = false;
                        Object.entries(error.response.data.errors).forEach((error) => {
                            this.errors[error[0]] = error[1];
                        });
                    });
                },

            },
            watch: {

            },
            mounted() {
                this.form.language = $('#form_subscribe_language').val();
                this.loading = false;
            }
        });

        /*setInterval(() => {
            let height = $('#subscribe-app').height();

            if(height > 0){
                $(parent.document).find('#iframe-form-subscribe').css('height', height);
            }

        }, 500);*/

    }

});

